module.exports = __webpack_public_path__ + "img/icon-sound.40840668.svg";